export const partnerAdditionalTranslation = {
  content: {
    blockTitles: {
      socialBlock: 'partnerinfo-content-blocktitles-social_block',
      linksBlock: 'partnerinfo-content-blocktitles-links_block',
    },
  },
}
